export function isEditable(attribute: { state?: string, status?: string } = {}) {
  return ![attribute.state, attribute.status].includes('ARCHIVED');
}
